(function () {
  'use strict';

  function initFinder(root) {
    if (!root || root.dataset.fpcInit === 'true') return;
    root.dataset.fpcInit = 'true';

    var config = {};
    try {
      config = JSON.parse(root.querySelector('[data-fpc-config]').textContent);
    } catch (e) {
      console.error('[FPC] Invalid config JSON', e);
      return;
    }

    var products = config.products || [];

    function logMenuWarnings() {
      var warnings = config.menuWarnings || [];
      warnings.forEach(function (w) {
        console.warn('[FPC Menu] ' + (w.title || 'Menu item') + ': ' + (w.reason || 'Invalid configuration'));
      });
      if (!products.length) {
        if (warnings.length) {
          console.warn('[FPC Menu] No valid recommendation products. Fix the menu items above.');
        } else {
          console.warn('[FPC Menu] No recommendation products. Assign a menu and use c:[capacity_wh] in each item title.');
        }
      }
    }

    logMenuWarnings();
    var totalSteps = 4;

    var state = {
      step: 1,
      scenario: null,
      appliances: [],
      needs: [],
      totalWh: 0,
      maxPeakW: 0,
      editingId: null,
      modalMode: 'custom',
      fallbackHeading: false
    };

    var steps = root.querySelectorAll('[data-fpc-step]');
    var progressBar = root.querySelector('[data-fpc-progress]');
    var btnBacks = root.querySelectorAll('[data-fpc-back]');
    var btnNext = root.querySelector('[data-fpc-next]');
    var footer = root.querySelector('[data-fpc-footer]');
    var totalEl = root.querySelector('[data-fpc-total]');
    var modal = root.querySelector('[data-fpc-modal]');
    var modalTitle = root.querySelector('[data-fpc-modal-title]');
    var inputWatts = root.querySelector('[data-fpc-input-watts]');
    var inputHours = root.querySelector('[data-fpc-input-hours]');
    var inputName = root.querySelector('[data-fpc-input-name]');
    var nameField = root.querySelector('[data-fpc-name-field]');
    var modalConfirm = root.querySelector('[data-fpc-modal-confirm]');
    var resultWrap = root.querySelector('[data-fpc-result]');
    var resultGrid = root.querySelector('[data-fpc-result-grid]');
    var noMatchEl = root.querySelector('[data-fpc-no-match]');
    var headingWrap = root.querySelector('[data-fpc-heading]');
    var headingTitleEl = headingWrap && headingWrap.querySelector('.t4s-section-title span');
    var headingSubtitleEl = headingWrap && headingWrap.querySelector('.t4s-subtitle');

    function initAppliances() {
      state.appliances = (config.appliances || []).map(function (a) {
        return {
          id: a.id,
          name: a.name,
          watts: a.watts,
          hours: a.hours,
          icon: a.icon,
          selected: false,
          custom: false
        };
      });
    }

    function formatWh(n) {
      return (Math.round(n * 100) / 100).toFixed(2);
    }

    function formatMoney(cents) {
      cents = parseInt(cents, 10);
      if (isNaN(cents)) cents = 0;

      var format = config.moneyFormat
        || (window.T4Sconfigs && window.T4Sconfigs.moneyFormat)
        || '€{{amount}}';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholderRegex);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        var num = (number / 100).toFixed(precision);
        var parts = num.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }

      var value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return format.replace(placeholderRegex, value);
    }

    function calcTotals() {
      var total = 0;
      var peak = 0;
      state.appliances.forEach(function (a) {
        if (!a.selected) return;
        total += a.watts * a.hours;
        if (a.watts > peak) peak = a.watts;
      });
      state.totalWh = total;
      state.maxPeakW = peak;
      if (totalEl) totalEl.textContent = formatWh(total);
    }

    function updateHeading() {
      var headings = (config.stepHeadings || {})[String(state.step)] || {};
      var title = headings.title || '';
      if (state.step === 4 && state.fallbackHeading) {
        title = (config.labels && config.labels.noMatchText) || title;
      }
      if (headingTitleEl) headingTitleEl.textContent = title;
      if (headingSubtitleEl) {
        headingSubtitleEl.textContent = headings.subtitle || '';
        headingSubtitleEl.style.display = headings.subtitle ? '' : 'none';
      }
    }

    function updateNav() {
      if (progressBar) {
        progressBar.style.width = ((state.step / totalSteps) * 100) + '%';
      }

      steps.forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.dataset.fpcStep, 10) === state.step);
      });

      btnBacks.forEach(function (btn) {
        var inStep4 = btn.closest('[data-fpc-step="4"]');
        if (inStep4) {
          btn.classList.toggle('fpc-hidden', state.step !== 4);
        } else {
          btn.classList.toggle('fpc-hidden', state.step === 1 || state.step === 4);
        }
      });

      if (footer) footer.classList.toggle('fpc-hidden', state.step === 4);

      if (btnNext) {
        var label = config.labels || {};
        btnNext.textContent = state.step === 3 ? (label.viewResult || 'Voir le résultat') : (label.next || 'Suivant');
        btnNext.disabled = !canProceed();
      }

      updateHeading();
    }

    function canProceed() {
      switch (state.step) {
        case 1:
          return !!state.scenario;
        case 2:
          return state.appliances.some(function (a) { return a.selected; });
        case 3:
          return true;
        default:
          return true;
      }
    }

    function createCardImage(src, alt, className) {
      if (!src) return '';
      return '<img src="' + src + '" alt="' + escapeHtml(alt || '') + '" decoding="async" draggable="false">';
    }

    function buildScenarioCards() {
      var grid = root.querySelector('[data-fpc-scenario-grid]');
      if (!grid || grid.dataset.fpcBuilt === 'true') return;
      grid.dataset.fpcBuilt = 'true';
      grid.innerHTML = '';
      (config.scenarios || []).forEach(function (s) {
        var card = document.createElement('div');
        card.className = 'fpc-card fpc-card--scenario';
        card.dataset.scenarioId = s.id;
        card.innerHTML =
          '<div class="fpc-card__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>' +
          (s.image ? '<div class="fpc-card__image">' + createCardImage(s.image, s.title) + '</div>' : '') +
          '<div class="fpc-card__label">' + escapeHtml(s.title) + '</div>';
        grid.appendChild(card);
      });

      grid.addEventListener('click', function (e) {
        var card = e.target.closest('[data-scenario-id]');
        if (!card) return;
        state.scenario = card.dataset.scenarioId;
        syncScenarioSelection();
        updateNav();
      });

      syncScenarioSelection();
    }

    function syncScenarioSelection() {
      var grid = root.querySelector('[data-fpc-scenario-grid]');
      if (!grid) return;
      grid.querySelectorAll('[data-scenario-id]').forEach(function (card) {
        card.classList.toggle('is-selected', card.dataset.scenarioId === state.scenario);
      });
    }

    function applianceMetaHtml(a) {
      var labels = config.labels || {};
      var outputLabel = labels.output || 'Puissance';
      var useTimeLabel = labels.useTime || 'Durée d\'utilisation';
      return escapeHtml(outputLabel) + ' ' + a.watts + ' W<br>' + escapeHtml(useTimeLabel) + ' ' + a.hours + ' h';
    }

    function createApplianceCard(a) {
      var card = document.createElement('div');
      card.className = 'fpc-card fpc-card--appliance' + (a.selected ? ' is-selected' : '');
      card.dataset.applianceId = a.id;
      card.innerHTML =
        '<div class="fpc-card__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>' +
        (a.icon ? '<div class="fpc-card__icon">' + createCardImage(a.icon, a.name) + '</div>' : '<div class="fpc-card__icon"></div>') +
        '<div class="fpc-card__name">' + escapeHtml(a.name) + '</div>' +
        '<div class="fpc-card__meta">' + applianceMetaHtml(a) + '</div>' +
        '<button type="button" class="fpc-card__edit" aria-label="' + escapeHtml((config.labels || {}).edit || 'Modifier') + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>' +
        '</button>';
      return card;
    }

    function syncApplianceCard(a) {
      var grid = root.querySelector('[data-fpc-appliance-grid]');
      if (!grid) return;
      var card = grid.querySelector('[data-appliance-id="' + a.id + '"]');
      if (!card) return;
      card.classList.toggle('is-selected', !!a.selected);
      var meta = card.querySelector('.fpc-card__meta');
      if (meta) meta.innerHTML = applianceMetaHtml(a);
    }

    function buildApplianceCards() {
      var grid = root.querySelector('[data-fpc-appliance-grid]');
      if (!grid || grid.dataset.fpcBuilt === 'true') return;
      grid.dataset.fpcBuilt = 'true';
      grid.innerHTML = '';

      state.appliances.forEach(function (a) {
        grid.appendChild(createApplianceCard(a));
      });

      var addCard = document.createElement('div');
      addCard.className = 'fpc-card fpc-card--appliance fpc-card--add';
      addCard.dataset.fpcAdd = 'true';
      addCard.innerHTML =
        '<div class="fpc-card__plus">+</div>' +
        '<div class="fpc-card__label">' + escapeHtml((config.labels || {}).addOwn || 'Ajouter un appareil') + '</div>';
      grid.appendChild(addCard);

      grid.addEventListener('click', function (e) {
        if (e.target.closest('.fpc-card__edit')) {
          e.stopPropagation();
          var editCard = e.target.closest('[data-appliance-id]');
          if (editCard) openModal('edit', editCard.dataset.applianceId);
          return;
        }
        if (e.target.closest('[data-fpc-add]')) {
          openModal('custom', null);
          return;
        }
        var card = e.target.closest('[data-appliance-id]');
        if (!card) return;
        var item = state.appliances.find(function (a) { return a.id === card.dataset.applianceId; });
        if (!item) return;
        item.selected = !item.selected;
        card.classList.toggle('is-selected', item.selected);
        calcTotals();
        updateNav();
      });

      calcTotals();
    }

    function appendApplianceCard(a) {
      var grid = root.querySelector('[data-fpc-appliance-grid]');
      if (!grid) return;
      var addCard = grid.querySelector('[data-fpc-add]');
      var card = createApplianceCard(a);
      if (addCard) grid.insertBefore(card, addCard);
      else grid.appendChild(card);
    }

    function buildNeedCards() {
      var grid = root.querySelector('[data-fpc-needs-grid]');
      if (!grid || grid.dataset.fpcBuilt === 'true') return;
      grid.dataset.fpcBuilt = 'true';
      grid.innerHTML = '';
      (config.needs || []).forEach(function (n) {
        var card = document.createElement('div');
        card.className = 'fpc-card fpc-card--need';
        card.dataset.needId = n.id;
        card.innerHTML =
          '<div class="fpc-card__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>' +
          (n.image ? '<div class="fpc-card__image">' + createCardImage(n.image, '') + '</div>' : '') +
          '<div class="fpc-card__text">' + escapeHtml(n.text) + '</div>';
        grid.appendChild(card);
      });

      grid.addEventListener('click', function (e) {
        var card = e.target.closest('[data-need-id]');
        if (!card) return;
        var id = card.dataset.needId;
        var idx = state.needs.indexOf(id);
        if (idx === -1) state.needs.push(id);
        else state.needs.splice(idx, 1);
        syncNeedSelection();
        updateNav();
      });

      syncNeedSelection();
    }

    function syncNeedSelection() {
      var grid = root.querySelector('[data-fpc-needs-grid]');
      if (!grid) return;
      grid.querySelectorAll('[data-need-id]').forEach(function (card) {
        card.classList.toggle('is-selected', state.needs.indexOf(card.dataset.needId) !== -1);
      });
    }

    function getMaxHours() {
      return config.maxCustomHours || 24;
    }

    function clampHoursInput() {
      if (!inputHours) return;
      var maxH = getMaxHours();
      var val = parseFloat(inputHours.value);
      if (!isNaN(val) && val > maxH) {
        inputHours.value = String(maxH);
      }
    }

    function getModalValues() {
      return {
        watts: parseFloat(inputWatts && inputWatts.value) || 0,
        hours: parseFloat(inputHours && inputHours.value) || 0
      };
    }

    function isModalValid() {
      var vals = getModalValues();
      var maxW = config.maxCustomWatts || 7200;
      var maxH = getMaxHours();
      return vals.watts > 0 && vals.hours > 0 && vals.watts <= maxW && vals.hours <= maxH;
    }

    function updateModalConfirm() {
      if (!modalConfirm) return;
      modalConfirm.disabled = !isModalValid();
    }

    function openModal(mode, applianceId) {
      state.modalMode = mode;
      state.editingId = applianceId;
      var labels = config.labels || {};
      if (modalTitle) modalTitle.textContent = mode === 'custom' ? (labels.customAppliance || 'Appareil personnalisé') : (labels.editAppliance || 'Modifier l\'appareil');

      if (nameField) nameField.classList.toggle('fpc-hidden', mode !== 'custom');

      if (mode === 'edit' && applianceId) {
        var item = state.appliances.find(function (a) { return a.id === applianceId; });
        if (item) {
          if (inputWatts) inputWatts.value = item.watts;
          if (inputHours) {
            inputHours.value = Math.min(item.hours, getMaxHours());
          }
        }
      } else {
        if (inputWatts) inputWatts.value = '0';
        if (inputHours) inputHours.value = '0';
        if (inputName) inputName.value = '';
      }

      if (modal) modal.classList.add('is-open');
      updateModalConfirm();
    }

    function closeModal() {
      if (modal) modal.classList.remove('is-open');
      state.editingId = null;
    }

    function confirmModal() {
      if (!isModalValid()) return;

      var vals = getModalValues();
      var watts = vals.watts;
      var hours = vals.hours;
      var maxW = config.maxCustomWatts || 7200;

      if (watts > maxW) {
        alert((config.labels || {}).maxWattsError || ('La puissance maximale est de ' + maxW + ' W'));
        updateModalConfirm();
        return;
      }

      var maxH = getMaxHours();
      if (hours > maxH) {
        alert((config.labels || {}).maxHoursError || ('La durée d\'utilisation maximale est de ' + maxH + ' heures'));
        updateModalConfirm();
        return;
      }

      if (state.modalMode === 'edit' && state.editingId) {
        var item = state.appliances.find(function (a) { return a.id === state.editingId; });
        if (item) {
          item.watts = watts;
          item.hours = hours;
          syncApplianceCard(item);
        }
      } else {
        var name = (inputName && inputName.value.trim()) || ('Custom ' + (state.appliances.filter(function (a) { return a.custom; }).length + 1));
        var newItem = {
          id: 'custom-' + Date.now(),
          name: name,
          watts: watts,
          hours: hours,
          icon: config.customApplianceIcon || '',
          selected: true,
          custom: true
        };
        state.appliances.push(newItem);
        appendApplianceCard(newItem);
      }

      closeModal();
      calcTotals();
      updateNav();
    }

    function normalizeTags(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val.map(function (v) { return String(v).trim(); }).filter(Boolean);
      if (typeof val === 'string') return val.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
      return [];
    }

    function getProductCapacity(p) {
      return p.capacity_wh || 0;
    }

    function passesScenario(p) {
      var scenarios = normalizeTags(p.scenarios);
      if (!scenarios.length) return true;
      return !!(state.scenario && scenarios.indexOf(state.scenario) !== -1);
    }

    function passesNeeds(p) {
      var selected = state.needs || [];
      if (!selected.length) return true;
      var needs = normalizeTags(p.needs);
      if (!needs.length) return true;
      for (var i = 0; i < selected.length; i++) {
        if (needs.indexOf(selected[i]) === -1) return false;
      }
      return true;
    }

    function needScore(p) {
      var score = p.priority || 0;
      var needs = normalizeTags(p.needs);
      state.needs.forEach(function (need) {
        if (needs.indexOf(need) !== -1) score += 10;
      });
      return score;
    }

    var STANDARD_CAPS = [1024, 2048, 3840, 5222, 7680, 10444, 11520, 15666];

    function closestStandardCap(refWh) {
      var best = STANDARD_CAPS[STANDARD_CAPS.length - 1];
      var bestDiff = Infinity;
      STANDARD_CAPS.forEach(function (cap) {
        var diff = Math.abs(cap - refWh);
        if (diff < bestDiff) {
          bestDiff = diff;
          best = cap;
        }
      });
      return best;
    }

    function getWhTierRule(totalWh) {
      if (totalWh < 2000) {
        return {
          mode: 'maxCap',
          maxCap: 2000,
          label: '<2000Wh → capacity <2000Wh'
        };
      }
      if (totalWh <= 3000) {
        return {
          mode: 'caps',
          caps: [2048],
          label: '2000–3000Wh → 2度电(2048Wh)'
        };
      }

      var bucket = Math.ceil(totalWh / 1000);
      var refWh = bucket * 1000;
      var intervalMin = (bucket - 1) * 1000;
      var intervalMax = bucket * 1000;
      var primary = closestStandardCap(refWh);
      var label = intervalMin + '–' + intervalMax + 'Wh → ' + primary + 'Wh';

      return { mode: 'caps', caps: [primary], refWh: refWh, label: label };
    }

    function productMatchesTier(p, rule) {
      var cap = getProductCapacity(p);
      if (rule.mode === 'maxCap') return cap < rule.maxCap;
      return rule.caps.indexOf(cap) !== -1;
    }

    function sortPoolByPreference(pool) {
      pool.sort(function (a, b) {
        return needScore(b) - needScore(a);
      });
      return pool;
    }

    var MAX_RECOMMEND = 2;

    function pickFromPool(pool, rule) {
      var results = [];
      var tierPool = pool.filter(function (p) {
        if (rule.mode === 'maxCap') {
          return getProductCapacity(p) < rule.maxCap;
        }
        return rule.caps.indexOf(getProductCapacity(p)) !== -1;
      });

      sortPoolByPreference(tierPool);
      tierPool.forEach(function (p) {
        if (results.length >= MAX_RECOMMEND) return;
        if (results.some(function (r) { return r.variant_id === p.variant_id; })) return;
        results.push(p);
      });

      return results;
    }

    function getTierPool(rule) {
      return products.filter(function (p) {
        if (!passesScenario(p)) return false;
        if (!passesNeeds(p)) return false;
        return productMatchesTier(p, rule);
      });
    }

    function logRecommendDebug(reason, extra) {
      if (typeof console === 'undefined' || !console.warn) return;
      console.warn('[FPC Recommend] ' + reason, {
        totalWh: state.totalWh,
        productCount: products.length,
        extra: extra || null
      });
    }

    function findAllMatches() {
      if (state.totalWh <= 0) {
        logRecommendDebug('totalWh is zero — select appliances in Step 2');
        return [];
      }

      if (!products.length) {
        logRecommendDebug('No products in recommendation menu');
        return [];
      }

      if (!state.needs.length) {
        logRecommendDebug('No needs selected — using fallback');
        return [];
      }

      var totalWh = state.totalWh;
      var rule = getWhTierRule(totalWh);
      var pool = getTierPool(rule);

      if (!pool.length) {
        logRecommendDebug('No perfect match (tier/scenario/needs)', {
          totalWh: totalWh,
          scenario: state.scenario,
          needs: state.needs,
          tier: rule.label,
          catalog: products.map(function (p) {
            return { title: p.title, cap: getProductCapacity(p), scenarios: p.scenarios, needs: p.needs };
          })
        });
        return [];
      }

      return pickFromPool(pool, rule);
    }

    function pickFallbackMatches() {
      if (state.totalWh <= 0 || !products.length) return [];

      var pool = products.slice();
      pool.sort(function (a, b) {
        var da = Math.abs(getProductCapacity(a) - state.totalWh);
        var db = Math.abs(getProductCapacity(b) - state.totalWh);
        if (da !== db) return da - db;
        return needScore(b) - needScore(a);
      });

      var results = [];
      pool.forEach(function (p) {
        if (results.length >= MAX_RECOMMEND) return;
        if (results.some(function (r) { return r.variant_id === p.variant_id; })) return;
        results.push(p);
      });

      logRecommendDebug('No perfect match — using closest fallback', {
        totalWh: state.totalWh,
        fallback: results.map(function (p) {
          return { title: p.title, cap: getProductCapacity(p) };
        })
      });

      return results;
    }

    function getPaymentTexts(match) {
      if (match && match.payment_texts && match.payment_texts.length) {
        return match.payment_texts.map(function (t) { return String(t).trim(); }).filter(Boolean);
      }
      var fallback = (match && match.payment_text) || config.klarnaText || '';
      return fallback ? [fallback] : [];
    }

    function buildKlarnaHtml(match) {
      if (!config.showKlarna) return '';
      var texts = getPaymentTexts(match);
      var paypal = config.paypalIcon || '';
      var klarna = config.klarnaIcon || '';
      if (!texts.length && !paypal && !klarna) return '';

      var textHtml = '';
      if (texts.length) {
        textHtml = '<span class="fpc-pr-card__klarna-texts">' +
          texts.map(function (t) {
            return '<span class="fpc-pr-card__klarna-text">' + escapeHtml(t) + '</span>';
          }).join('') +
          '</span>';
      }

      var icons = '';
      if (paypal) icons += '<img src="' + paypal + '" alt="PayPal" class="fpc-pr-card__pay-icon" loading="lazy">';
      if (klarna) icons += '<img src="' + klarna + '" alt="Klarna" class="fpc-pr-card__pay-icon" loading="lazy">';

      return '<div class="fpc-pr-card__klarna">' +
        textHtml +
        (icons ? '<span class="fpc-pr-card__pay-icons">' + icons + '</span>' : '') +
        '</div>';
    }

    function buildProductCard(match) {
      var labels = config.labels || {};
      var badgeHtml = match.discount_pct > 0
        ? '<div class="fpc-pr-card__badge">' + match.discount_pct + '% OFF</div>'
        : '';

      var compareHtml = match.compare_at_price > match.price
        ? '<s class="fpc-pr-card__price-compare">' + formatMoney(match.compare_at_price) + '</s>'
        : '';

      return '<div class="fpc-pr-card">' +
        badgeHtml +
        '<div class="fpc-pr-card__image">' +
          (match.image ? '<img src="' + match.image + '" alt="' + escapeHtml(match.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="fpc-pr-card__body">' +
          '<div class="fpc-pr-card__title">' + escapeHtml(match.title) + '</div>' +
          buildKlarnaHtml(match) +
          '<div class="fpc-pr-card__price">' +
            '<span class="fpc-pr-card__price-sale">' + formatMoney(match.price) + '</span>' +
            compareHtml +
          '</div>' +
          '<div class="fpc-pr-card__buttons">' +
            '<a href="' + (match.url || '#') + '" class="fpc-pr-btn fpc-pr-btn--outline" data-variant-id="' + match.variant_id + '" data-action-atc rel="nofollow">' +
              escapeHtml(labels.addToCart || 'Ajouter au panier') +
            '</a>' +
            '<a href="' + (match.url || '#') + '" class="fpc-pr-btn fpc-pr-btn--solid">' +
              escapeHtml(labels.learnMore || 'En savoir plus') +
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function renderResult() {
      var matches = findAllMatches();
      var isFallback = false;

      if (!matches.length) {
        matches = pickFallbackMatches();
        isFallback = matches.length > 0;
      }

      state.fallbackHeading = isFallback;

      if (!matches.length) {
        if (resultWrap) resultWrap.classList.add('fpc-hidden');
        if (noMatchEl) noMatchEl.classList.remove('fpc-hidden');
        return;
      }

      if (resultWrap) resultWrap.classList.remove('fpc-hidden');
      if (noMatchEl) noMatchEl.classList.add('fpc-hidden');

      if (resultGrid) {
        resultGrid.innerHTML = matches.map(buildProductCard).join('');
      }
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function getStickyHeaderOffset() {
      var header = document.querySelector('.t4s-section-header');
      if (!header) return 0;
      var style = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();
      var stuck = document.documentElement.classList.contains('is-header--stuck') ||
        document.body.classList.contains('is-header--stuck') ||
        style.position === 'fixed' ||
        style.position === 'sticky' ||
        rect.top <= 1;
      if (!stuck || rect.height <= 0) return 0;
      return Math.ceil(rect.bottom > 0 ? Math.min(rect.bottom, rect.height) : rect.height);
    }

    function scrollStepToTop() {
      var target = headingWrap || root;
      if (!target) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var y = window.pageYOffset + target.getBoundingClientRect().top - getStickyHeaderOffset() - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function goStep(delta) {
      var next = state.step + delta;
      if (next < 1 || next > totalSteps) return;
      if (delta > 0 && !canProceed()) return;

      if (next === 4) {
        calcTotals();
        renderResult();
      }

      state.step = next;
      updateNav();

      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(scrollStepToTop);
      });
    }

    btnBacks.forEach(function (btn) {
      btn.addEventListener('click', function () { goStep(-1); });
    });
    if (btnNext) btnNext.addEventListener('click', function () { goStep(1); });

    root.querySelectorAll('[data-fpc-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    root.querySelector('[data-fpc-modal-overlay]') && root.querySelector('[data-fpc-modal-overlay]').addEventListener('click', closeModal);
    if (modalConfirm) modalConfirm.addEventListener('click', confirmModal);

    [inputWatts, inputHours].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        if (input === inputHours) clampHoursInput();
        updateModalConfirm();
      });
      input.addEventListener('change', function () {
        if (input === inputHours) clampHoursInput();
        updateModalConfirm();
      });
    });

    initAppliances();
    buildScenarioCards();
    buildApplianceCards();
    buildNeedCards();
    updateNav();
  }

  function boot() {
    document.querySelectorAll('[data-fpc-root]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fpc-root]');
    if (root) initFinder(root);
  });
})();
